import { defineMessages } from '@sevenrooms/locales'

export const upgradeDetailsMessages = defineMessages({
  title: {
    id: 'upgrade.details.title',
    defaultMessage: 'Upgrades',
  },
})
